import Immutable from 'immutable';
import cookies from 'js-cookie';

import { cookieNames } from '~client/constants/storage';
import { accountActionTypes } from '~constants/actionTypes';
import { defaultCommunicationObject, updateCommunicationObject } from '~reducers/shared';

export const defaultState = Immutable.fromJS({
  list: {
    payload: [],
    total: 0,
  },
  communication: {
    create: defaultCommunicationObject,
    update: defaultCommunicationObject,
    list: defaultCommunicationObject,
  },
  account: null,
});

const getCookieDomain = () => {
  return window.location.hostname.split('.').slice(-2).join('.');
};

const formatPayload = users =>
  users.map(user => ({
    id: user.node.id,
    slug: user.node.slug,
    firstName: user.node.firstName,
    lastName: user.node.lastName,
    email: user.node.email,
    updatedAt: user.node.updatedAt,
    userRoles: user.node.userRoles,
    userUuid: user.node.userUuid,
    landlord: user.node.landlord,
    enabled: user.node.enabled,
  }));

const accountReducer = (state = defaultState, action) => {
  switch (action.type) {
    case accountActionTypes.SET_CMS_USER:
      cookies.set(
        cookieNames.landlordContact,
        `${action.payload?.firstName ?? ''} ${action.payload.lastName ?? ''}`,
        {
          path: '/',
          expires: 2,
          domain: getCookieDomain(),
        },
      );

      return state.merge({
        account: action.payload,
      });

    case accountActionTypes.CREATE_CS:
      return state.mergeDeep({
        communication: {
          create: updateCommunicationObject(action.status, action.error),
        },
      });

    case accountActionTypes.UPDATE_CS:
      return state.mergeDeep({
        communication: {
          update: updateCommunicationObject(action.status, action.error),
        },
      });

    case accountActionTypes.INITIALIZE:
      return state;

    case accountActionTypes.SET_LIST: {
      const nextState = state.deleteIn(['list', 'payload']);
      return nextState.mergeDeep({
        list: {
          payload: formatPayload(action.payload.edges),
          total: action.payload.totalCount,
        },
      });
    }

    case accountActionTypes.LIST_CS:
      return state.mergeDeep({
        communication: {
          list: updateCommunicationObject(action.status, action.error),
        },
      });

    default:
      return state;
  }
};

export default accountReducer;
